import { DropdownFieldWrapper } from "@app/shared/components/DropdownFieldWrapper/DropdownFieldWrapper";
import { useCurrentUserLocale } from "@app/shared/utils/currentUserLocale";
import { SupportedLocales } from "@app/shared/utils/locales";
import { Icon } from "@design-system/Icon";
import { Calendar } from "@design-system/Inputs/Calendar";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Text } from "@design-system/Typography/Text";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "./i18n";

export const DateInputDropdown = ({
    value,
    onChange,
}: {
    value: Date | undefined;
    onChange: (value: Date | undefined) => void;
}) => {
    const { t } = useTranslation(RESOURCE_NAME);
    const userLocale = useCurrentUserLocale(SupportedLocales.EN);

    const handleChange = (date: Date | undefined) => {
        onChange(date);
    };

    const displayedDate = value ? dayjs(value).format("MMM D, YYYY") : "";

    return (
        <Dropdown>
            <Dropdown.Trigger className="w-[204px]">
                <DropdownFieldWrapper
                    placeholder={t(
                        keys.create_questionnaire_modal_deadline_placeholder,
                    )}
                    placeholderUp={!!value}
                    leadingElement={
                        <Icon name="calendar" className="text-neutral-500" />
                    }
                    trailingElement={<Icon name="chevronDown" />}
                >
                    <Text>{displayedDate}</Text>
                </DropdownFieldWrapper>
            </Dropdown.Trigger>
            <Dropdown.Content align="start" hasPortal>
                <Calendar
                    mode="single"
                    defaultMonth={value ? new Date(value) : new Date()}
                    selected={value}
                    onSelect={handleChange}
                    locale={{ code: userLocale }}
                    required={false}
                    className="rounded-md border"
                    disabled={{ before: new Date() }}
                />
            </Dropdown.Content>
        </Dropdown>
    );
};
